import { validFileName } from 'Helpers/File';

// This used to have its own implementation, but it was identical to the one in ../../Helpers/File,
// so I changed this function to use that implementation to keep things consolidated and backwards
// compatible.
export const validateFileName = validFileName;
export const validateFolderName = validFileName;
